import React, { useEffect } from "react";
import { useParams, withRouter } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

import { admin_cse } from "@/config/roles";
import { FeatureFlagEnum } from "@/features/feature-flag/constants";
import { FeatureGate } from "@/features/feature-flag/components/FeatureGate";
import { isAuthorized } from "@/utils/authToken";
import { patientKeys } from "@/features/patient/api/keyFactory";
import { timelineKeys } from "@/features/member-profile/(timeline)/api/keyFactory";

import ChangePatientEmailCard from "./Admin/ChangePatientEmailCard";
import ChangePatientPracticeCard from "./Admin/ChangePatientPracticeCard";
import OverridePatientAutocharge from "./Admin/OverridePatientAutocharge";
import ResetPatientPasswordCard from "./Admin/ResetPatientPasswordCard";
import RestrictPatientSchedulingCard from "./Admin/RestrictPatientSchedulingCard";
import VerifyPatientEmailCard from "./Admin/VerifyPatientEmailCard";

const MemberProfileAdmin = (props) => {
  const { patientId } = useParams();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!isAuthorized(admin_cse)) {
      props.history.push("/app/home");
    }
  }, [props.history]);

  const refetchDetails = () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: patientKeys.details(patientId) }),
      queryClient.invalidateQueries({ queryKey: timelineKeys.feed(patientId) }),
    ]);

  return (
    <div className="AdminTab">
      <div className="mt-3 mb-3">
        <ChangePatientEmailCard
          patientDetails={props.patientDetails}
          refetchPatientDetails={props.refetchPatientDetails}
        />
      </div>

      <div className="mb-3">
        <VerifyPatientEmailCard patientDetails={props.patientDetails} />
      </div>

      <div className="mb-3">
        <ResetPatientPasswordCard
          patientDetails={props.patientDetails}
          refetchPatientDetails={props.refetchPatientDetails}
        />
      </div>

      <div className="mb-3">
        <ChangePatientPracticeCard
          patientDetails={props.patientDetails}
          refetchPatientDetails={props.refetchPatientDetails}
        />
      </div>

      <div className="mb-3">
        <OverridePatientAutocharge
          patientDetails={props.patientDetails}
          refetchPatientDetails={props.refetchPatientDetails}
          selectedTabChangeHandler={props.selectedTabChangeHandler}
        />
      </div>

      <FeatureGate
        defaultFlagValue={false}
        disabledFallback={<></>}
        flagName={FeatureFlagEnum.restrictPatientScheduling}
      >
        <div className="mb-3" ref={props?.adminFocusRef}>
          <RestrictPatientSchedulingCard
            patientDetails={props.patientDetails}
            refetchDetails={refetchDetails}
          />
        </div>
      </FeatureGate>
    </div>
  );
};

export default withRouter(MemberProfileAdmin);
